module.exports = __webpack_public_path__ + "img/3.ab56b559.jpg";